



































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TbReport, TbMember } from "@/http";
import { Toast } from "vant";
import { calendarPanel, NumberKeyboard } from "@/components";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { fmoney } from "@/common/util/money";
import calculate from "@/common/util/calculate";
dayjs.locale("zh-cn");
@Component({
  components: {
    calendarPanel,
    NumberKeyboard,
  },
})
export default class vipbb extends Vue {
  public $refs: {
    detail: HTMLFormElement;
  };

  @Prop({ default: "" }) curZLStr: string;
  curZL = 1;
  fmoney = fmoney;
  /**查询项- */
  searchValue1 = {
    shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
    phone: "",
    tradeType: null,
    startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
    endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    skip: 0,
    count: 10,
  };
  searchValue2 = {
    shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
    phone: "",
    paymentMethod: null,
    startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
    endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    skip: 0,
    count: 10,
  };
  searchValue3 = {
    shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
    phone: "",
    changeType: null,
    startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
    endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    skip: 0,
    count: 10,
  };
  searchValue4 = {
    shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
    phone: "",
    tradeStatus: null,
    startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
    endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    skip: 0,
    count: 10,
  };
  /**时间类型下拉 */
  showStatusPopover = false;
  payType = null;
  payOptions = [
    {
      label: "全部交易类型",
      value: null,
    },
    {
      label: "充值",
      value: 1,
    },
    {
      label: "销售",
      value: 2,
    },
    {
      label: "退货",
      value: 3,
    },
  ];
  payOptions2 = [
    {
      label: "全部支付方式",
      value: null,
    },
    {
      label: "现金",
      value: 2,
    },
    {
      label: "微信",
      value: 3,
    },
    {
      label: "支付宝",
      value: 4,
    },
    {
      label: "线下微信",
      value: 13,
    },
    {
      label: "线下支付宝",
      value: 14,
    },
  ];
  payOptions3 = [
    {
      label: "全部变动类型",
      value: null,
    },
    {
      label: "充值得积分",
      value: 1,
    },
    {
      label: "消费得积分",
      value: 2,
    },
    {
      label: "积分抵扣现金",
      value: 3,
    },
    {
      label: "积分调整-增加",
      value: 4,
    },
    {
      label: "积分调整-减少",
      value: 5,
    },
  ];
  payType4 = null;
  payOptions4 = [
    {
      label: "全部交易状态",
      value: null,
    },
    {
      label: "待支付",
      value: 1,
    },
    {
      label: "支付失败",
      value: 3,
    },
    {
      label: "已关闭",
      value: 4,
    },
  ];

  /**时间控件 */
  pickerShow = false;
  startDate = dayjs(new Date()).format("YYYY-MM-DD");
  endDate = dayjs(new Date()).format("YYYY-MM-DD");

  /**列表展示
   * 1:图
   * 2：表格
   */
  showType = 1;

  userInfo: any = {};

  /**列表加载相关 */
  refreshing = false;
  loading = false;
  finished = false;
  list = [];
  list2 = [];
  list3 = [];
  list4 = [];
  total = 0;
  currentPage = 1;
  totalStock = 0;

  timeActive = null;
  hj_ze = "0.00";
  hj_xsnum = 0;
  hj_the = "0.00";
  hj_sxze = "0.00";
  hj_zkze = "0.00";

  hj_xjnovip = "0.00";
  hj_xj = "0.00";
  hj_cash = "0.00";
  hj_wechat = "0.00";
  hj_alipay = "0.00";
  hj_vipcard = "0.00";
  hj3_ze = "0.00";
  hj3_sxze = "0.00";
  hj3_czze = "0.00";

  get getPayStatus() {
    let str = "";
    str = this.payOptions.find((v) => v.value == this.payType).label;
    return str;
  }
  get getPayStatus2() {
    let str = "";
    str = this.payOptions2.find((v) => v.value == this.payType).label;
    return str;
  }
  get getPayStatus3() {
    let str = "";
    str = this.payOptions3.find((v) => v.value == this.payType).label;
    return str;
  }
  get getPayStatus4() {
    let str = "";
    str = this.payOptions4.find((v) => v.value == this.payType4).label;
    return str;
  }

  @Watch("searchValue1.orderNo")
  nameChange(val) {
    this.getList();
  }
  @Watch("searchValue1.memberPhone")
  nameChange2(val) {
    this.getList();
  }
  created() {}

  async mounted() {
    if (this.curZLStr) {
      this.curZL = Number(this.curZLStr);
    }
    this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
    this.getList();
  }

  chooseZL(tag) {
    this.curZL = tag;
    this.clearSearch();
    this.getList();
  }
  clearSearch() {
    switch (this.curZL) {
      case 1:
        this.searchValue1 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          phone: "",
          tradeType: null,
          startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
        };
        break;
      case 2:
        this.searchValue2 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          phone: "",
          paymentMethod: null,
          startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
        };
        break;
      case 3:
        this.searchValue3 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          phone: "",
          changeType: null,
          startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
        };
        break;
      case 4:
        this.searchValue4 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          phone: "",
          tradeStatus: null,
          startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
        };
        break;
      default:
        break;
    }
    this.payType = null;
    this.payType4 = null;
    this.searchValue1.tradeType = null;
    this.searchValue2.paymentMethod = null;
    this.searchValue3.changeType = null;
    this.searchValue4.tradeStatus = null;
    this.timeActive = null;
    this.startDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
  }

  openselDate() {
    this.pickerShow = true;
  }
  /**确定选择时间 */
  onselConfirm(date) {
    const [start, end] = date;
    this.startDate = dayjs(start).format("YYYY-MM-DD");
    this.endDate = dayjs(end).format("YYYY-MM-DD");

    this.pickerShow = false;
    this.timeActive = null;
    this.setTimeSearch();
  }
  closeTime() {
    this.pickerShow = false;
  }

  /**下拉刷新 */
  onRefresh() {
    // 清空列表数据
    this.finished = false;
    // 重新加载数据
    // 将 loading 设置为 true，表示处于加载状态
    this.loading = true;
    let arg =
      this.curZL == 1
        ? "searchValue1"
        : this.curZL == 2
        ? "searchValue2"
        : this.curZL == 3
        ? "searchValue3"
        : this.curZL == 4
        ? "searchValue4"
        : "searchValue1";
    this[arg].skip = 0;
    this[arg].count = 10;
    this.currentPage = 1;
    this.loadMore();
  }
  /**触底加载 */
  async loadMore() {
    let arg =
      this.curZL == 1
        ? "searchValue1"
        : this.curZL == 2
        ? "searchValue2"
        : this.curZL == 3
        ? "searchValue3"
        : this.curZL == 4
        ? "searchValue4"
        : "searchValue1";
    let arg2 =
      this.curZL == 1
        ? "list"
        : this.curZL == 2
        ? "list2"
        : this.curZL == 3
        ? "list3"
        : this.curZL == 4
        ? "list4"
        : "list";
    if (this.refreshing) {
      this[arg2] = [];
      this.refreshing = false;
    }
    let s = this[arg].count;
    switch (this.curZL) {
      // 会员交易明细
      case 1:
        let resjy = await TbReport.GetMemberTradeReport(Object.assign({}, this[arg]));
        this.list =
          this[arg].skip == 0
            ? resjy.items.map((v) => {
                return {
                  ...v,
                  createTime: dayjs(v.createTime).format("YYYY-MM-DD"),
                };
              })
            : this.list.concat(
                resjy.items.map((v) => {
                  return {
                    ...v,
                    createTime: dayjs(v.createTime).format("YYYY-MM-DD"),
                  };
                })
              );
        this.total = resjy.totalCount;
        break;
      // 会员充值明细
      case 2:
        let reszf = await TbReport.GetMemberRechargeReport(Object.assign({}, this[arg]));
        this.list2 =
          this[arg].skip == 0
            ? reszf.items.map((v) => {
                return {
                  ...v,
                  createTime: dayjs(v.createTime).format("YYYY-MM-DD"),
                };
              })
            : this.list2.concat(
                reszf.items.map((v) => {
                  return {
                    ...v,
                    createTime: dayjs(v.createTime).format("YYYY-MM-DD"),
                  };
                })
              );
        this.total = reszf.totalCount;
        break;
      // 会员积分明细
      case 3:
        let resjf = await TbReport.GetMemberScoreReport(Object.assign({}, this[arg]));
        this.list3 =
          this[arg].skip == 0
            ? resjf.items.map((v) => {
                return {
                  ...v,
                  createTime: dayjs(v.createTime).format("YYYY-MM-DD"),
                };
              })
            : this.list3.concat(
                resjf.items.map((v) => {
                  return {
                    ...v,
                    createTime: dayjs(v.createTime).format("YYYY-MM-DD"),
                  };
                })
              );
        this.total = resjf.totalCount;
        break;
      // 异常充值订单
      case 4:
        let resyc = await TbMember.GetMemberRechargeExceptionList({
          TradeStatus: this.searchValue4.tradeStatus,
          PhoneOrName: this.searchValue4.phone,
          ShopId: this.searchValue4.shopId,
          StartTime: this.searchValue4.startTime,
          EndTime: this.searchValue4.endTime,
          skip: this.searchValue4.skip,
          count: this.searchValue4.count,
        });
        this.list4 =
          this.searchValue4.skip == 0
            ? resyc.items.map((v) => {
                return {
                  ...v,
                  createTime: dayjs(v.createTime).format("YYYY-MM-DD HH:mm:ss"),
                };
              })
            : this.list4.concat(
                resyc.items.map((v) => {
                  return {
                    ...v,
                    createTime: dayjs(v.createTime).format("YYYY-MM-DD HH:mm:ss"),
                  };
                })
              );
        this.total = resyc.totalCount;
        break;
      default:
        break;
    }
    this.currentPage++;
    this[arg].skip = (this.currentPage - 1) * s;
    this.loading = false;
    if (this[arg2].length >= this.total) {
      this.finished = true;
    }
  }
  /**获取商品列表 */
  async getList() {
    this.onRefresh();
  }
  /**重置 */
  resetSearch() {
    switch (this.curZL) {
      case 1:
        this.searchValue1 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          phone: "",
          tradeType: null,
          startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
        };
        break;
      case 2:
        this.searchValue2 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          phone: "",
          paymentMethod: null,
          startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
        };
        break;
      case 3:
        this.searchValue3 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          phone: "",
          changeType: null,
          startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
        };
        break;
      case 4:
        this.searchValue4 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          phone: "",
          tradeStatus: null,
          startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
        };
        break;
      default:
        break;
    }
    this.payType = null;
    this.payType4 = null;
    this.searchValue1.tradeType = null;
    this.searchValue2.paymentMethod = null;
    this.searchValue3.changeType = null;
    this.searchValue4.tradeStatus = null;
    this.timeActive = null;
    this.showStatusPopover = false;
    this.startDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.getList();
  }
  changeTimeStatusXL(item, index) {
    this.payType = item.value;
    if (this.curZL == 1) {
      this.searchValue1.tradeType = this.payType;
    }
    if (this.curZL == 2) {
      this.searchValue2.paymentMethod = this.payType;
    }
    if (this.curZL == 3) {
      this.searchValue3.changeType = this.payType;
    }
    if (this.curZL == 4) {
      this.payType4 = item.value;
      this.searchValue4.tradeStatus = item.value;
    }
    this.showStatusPopover = false;
    this.setTimeSearch();
  }
  async chooseTime(type) {
    this.timeActive = type;
    // 获取当前日期
    const today = dayjs();
    const firstDayOfWeek = dayjs().startOf("week");
    const firstDayOfMonth = dayjs().startOf("month");
    const prevMonthStart = today.subtract(1, "month").startOf("month");
    const prevMonthEnd = today.subtract(1, "month").endOf("month");
    switch (type) {
      case 1:
        this.startDate = today.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 2:
        this.startDate = firstDayOfWeek.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 3:
        this.startDate = firstDayOfMonth.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 4:
        this.startDate = prevMonthStart.format("YYYY-MM-DD");
        this.endDate = prevMonthEnd.format("YYYY-MM-DD");
        break;

      default:
        break;
    }
    await this.setTimeSearch();
  }
  async setTimeSearch() {
    switch (this.curZL) {
      case 1:
        this.searchValue1.startTime = this.startDate ? this.startDate + " 00:00:00" : "";
        this.searchValue1.endTime = this.endDate ? this.endDate + " 23:59:59" : "";
        break;
      case 2:
        this.searchValue2.startTime = this.startDate ? this.startDate + " 00:00:00" : "";
        this.searchValue2.endTime = this.endDate ? this.endDate + " 23:59:59" : "";
        break;
      case 3:
        this.searchValue3.startTime = this.startDate ? this.startDate + " 00:00:00" : "";
        this.searchValue3.endTime = this.endDate ? this.endDate + " 23:59:59" : "";
        break;
      case 4:
        this.searchValue4.startTime = this.startDate ? this.startDate + " 00:00:00" : "";
        this.searchValue4.endTime = this.endDate ? this.endDate + " 23:59:59" : "";
        break;
      default:
        break;
    }
    await this.getList();
  }

  getPayType(val) {
    let text = "/";
    switch (val) {
      case 1:
        text = "会员卡";
        break;
      case 2:
        text = "现金";
        break;
      case 3:
        text = "微信";
        break;
      case 4:
        text = "支付宝";
        break;
      case 5:
        text = "现金/会员卡/微信";
        break;
      case 6:
        text = "现金/会员卡/支付宝";
        break;
      case 7:
        text = "现金/微信";
        break;
      case 8:
        text = "现金/支付宝";
        break;
      case 9:
        text = "会员卡/微信";
        break;
      case 10:
        text = "会员卡/支付宝";
        break;
      case 11:
        text = "现金/会员卡";
        break;
      case 13:
        text = "线下微信";
        break;
      case 14:
        text = "线下支付宝";
        break;
      case 15:
        text = "现金/线下支付宝";
        break;
      case 16:
        text = "会员卡/线下支付宝";
        break;
      case 17:
        text = "现金/线下微信";
        break;
      case 18:
        text = "会员卡/线下微信";
        break;
      case 19:
        text = "线下微信/线下支付宝";
        break;
      case 20:
        text = "现金/会员卡/线下支付宝";
        break;
      case 21:
        text = "现金/会员卡/线下微信";
        break;
      case 22:
        text = "现金/线下支付宝/线下微信";
        break;
      case 23:
        text = "会员卡/线下支付宝/线下微信";
        break;
      case 24:
        text = "会员卡/线下支付宝/线下微信/现金";
        break;
      default:
        break;
    }
    return text;
  }
  /**查询支付结果 */
  async searchPay(item) {
    let res = await TbMember.GetMemberTradePayStatus({ orderId: item.id });
    let content =
      res.tradeStatus == 2
        ? "支付成功"
        : res.tradeStatus == 3
        ? "支付失败"
        : res.tradeStatus == 4
        ? "订单已关闭"
        : res.tradeStatus == 1
        ? "待支付"
        : "未获取到支付结果";
    Toast(content);
    this.getList();
  }
  finishPhone(val) {
    this["searchValue" + this.curZL].phone = val;
    this.getList();
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/report/components/vipbb.vue